import React from 'react';
import styles from './index.module.less';
import Image from 'next/image';

const TrustedFor: React.FC<{ data: any }> = ({ data }) => {
  return (
    <div className={styles.trustedFor}>
      <div className={styles.container}>
        {/* 标题区域 */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{data.title}</h2>
          {data.desc && (<p className={styles.subtitle}>{data.desc}</p>)}
        </div>

        {/* 功能项目网格 */}
        <div className={styles.itemsGrid}>
          {data.cards.map((item: any) => (
            <div key={item.id} className={styles.item}>
              <div className={styles.iconWrapper}>
                {item.imgPath && (
                  <Image src={item.imgPath} alt={item.title} className={styles.icon} width={40} height={40} />
                )}
              </div>
              <h3 className={styles.itemTitle}>{item.title}</h3>
              <p className={styles.itemDescription}>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustedFor;
